import React from 'react';
import Grid from "@material-ui/core/Grid";
import {makeStyles, Theme} from "@material-ui/core/styles";
import RiskCurvesPlot, {PlotTypes} from './RiskCurvesPlot';
import { acceptanceLinesContext } from '../Primitives/AcceptanceLinesContext';

const useStyles = makeStyles((theme: Theme) => ({
	plotContainer: {
		width: "max-content",
	},
	fullHeight: {
		height: '100%'
	},
}));

interface Props {
	acresXY?: any[],
	buildingImpactedXY?: any[],
	populationImpactedXY?: any[],
	combinedImpactXY?: any[],
	acresNoPSPSXY?: any[],
	acresPSPSXY?: any[],
	buildingImpactedNoPSPSXY?: any[],
	buildingImpactedPSPSXY?: any[],
	populationImpactedNoPSPSXY?: any[],
	populationImpactedPSPSXY?: any[],
	combinedImpactNoPSPSXY?: any[],
	combinedImpactPSPSXY?: any[],
	withAcceptanceLines?: boolean,
	hideBaseCurves?: boolean,
	type: "tline" | "assets"
}
const RiskCurvesContent = (props: Props) => {
	const { acresXY, buildingImpactedXY, populationImpactedXY, combinedImpactXY, acresNoPSPSXY, acresPSPSXY, buildingImpactedNoPSPSXY, buildingImpactedPSPSXY, populationImpactedNoPSPSXY, populationImpactedPSPSXY, combinedImpactNoPSPSXY, combinedImpactPSPSXY, withAcceptanceLines, hideBaseCurves, type} = props;

	const classes = useStyles();

	// Acres Plot Data
	const acresData: any[] = [];
	if (acresXY && !hideBaseCurves) acresData.push({
		x: acresXY[0],
		y: acresXY[1],
		type: 'scatter',
		name: "Base Curve",
		line: {
			color: "#008ABC"
		}
	});
	if (acresNoPSPSXY) acresData.push({
		x: acresNoPSPSXY[0],
		y: acresNoPSPSXY[1],
		type: 'scatter',
		name: 'Without PSPS',
		line: {
			color: "orange"
		}
	});
	if (acresPSPSXY) acresData.push({
		x: acresPSPSXY[0],
		y: acresPSPSXY[1],
		type: 'scatter',
		name: 'With PSPS',
		line: {
			color: "green"
		}
	});

	// Building Impacted Plot data
	const buildingImpactedData: any[] = [];
	if (buildingImpactedXY && !hideBaseCurves) buildingImpactedData.push({
		x: buildingImpactedXY[0],
		y: buildingImpactedXY[1],
		type: 'scatter',
		name: "Base Curve",
		line: {
			color: "#008ABC"
		}
	});
	if (buildingImpactedNoPSPSXY) buildingImpactedData.push({
		x: buildingImpactedNoPSPSXY[0],
		y: buildingImpactedNoPSPSXY[1],
		type: 'scatter',
		name: "Without PSPS",
		line: {
			color: "orange"
		}
	});
	if (buildingImpactedPSPSXY) buildingImpactedData.push({
		x: buildingImpactedPSPSXY[0],
		y: buildingImpactedPSPSXY[1],
		type: 'scatter',
		name: "With PSPS",
		line: {
			color: "green"
		}
	});

	// Population Impacted Plot Data
	const populationData: any[] = [];
	if (populationImpactedXY && !hideBaseCurves) populationData.push({
		x: populationImpactedXY[0],
		y: populationImpactedXY[1],
		type: 'scatter',
		name: "Base Curve",
		line: {
			color: "#008ABC"
		}
	});
	if (populationImpactedNoPSPSXY) populationData.push({
		x: populationImpactedNoPSPSXY[0],
		y: populationImpactedNoPSPSXY[1],
		type: 'scatter',
		name: "Without PSPS",
		line: {
			color: "orange"
		}
	});
	if (populationImpactedPSPSXY) populationData.push({
		x: populationImpactedPSPSXY[0],
		y: populationImpactedPSPSXY[1],
		type: 'scatter',
		name: "With PSPS",
		line: {
			color: "green"
		}
	});

	// Combined Impacted Plot Data
	const combinedImpactData: any[] = [];
	if (combinedImpactXY && !hideBaseCurves) combinedImpactData.push({
		x: combinedImpactXY[0],
		y: combinedImpactXY[1],
		type: 'scatter',
		name: "Base Curve",
		line: {
			color: "#008ABC"
		}
	});
	if (combinedImpactNoPSPSXY) combinedImpactData.push({
		x: combinedImpactNoPSPSXY[0],
		y: combinedImpactNoPSPSXY[1],
		type: 'scatter',
		name: "Without PSPS",
		line: {
			color: "#487eb0"
		}
	});
	if (combinedImpactPSPSXY) combinedImpactData.push({
		x: combinedImpactPSPSXY[0],
		y: combinedImpactPSPSXY[1],
		type: 'scatter',
		name: "With PSPS",
		line: {
			color: "#6c5ce7"
		}
	});

	return (
		<acceptanceLinesContext.Consumer>
			{
				value => (
					<Grid container className={`${classes.plotContainer} ${classes.fullHeight}`}>
						{ acresData.length > 0 && <RiskCurvesPlot data={acresData} xAxisTitle={PlotTypes.ACRES} withAcceptanceLines={withAcceptanceLines} acceptanceLines={value} type={type} />}
						{ buildingImpactedData.length > 0 && <RiskCurvesPlot data={buildingImpactedData} xAxisTitle={PlotTypes.BUILDING_IMPACTED} withAcceptanceLines={withAcceptanceLines} acceptanceLines={value} type={type} />}
						{ populationData.length > 0 &&<RiskCurvesPlot data={populationData} xAxisTitle={PlotTypes.POPULATION_IMPACTED} withAcceptanceLines={withAcceptanceLines} acceptanceLines={value} type={type} />}
						{ combinedImpactData.length > 0 && <RiskCurvesPlot data={combinedImpactData} xAxisTitle={PlotTypes.COMBINED_IMPACT} weights={true} withAcceptanceLines={withAcceptanceLines} acceptanceLines={value} type={type} /> }
					</Grid>
				)
			}
		</acceptanceLinesContext.Consumer>
	);
};

export default RiskCurvesContent;